import { readSsoConfig } from './config'
import { refreshAccessToken } from './oidc'
import {
  clearTokens,
  isTokenExpired,
  readStoredTokens,
  saveTokens,
  type StoredTokens,
} from './session'

export interface FreshTokenOptions {
  forceRefresh?: boolean
}

let inFlightRefresh: Promise<string | null> | null = null

export async function getFreshAccessToken(
  options: FreshTokenOptions = {},
): Promise<string | null> {
  const stored = readStoredTokens()
  if (!stored) return null

  if (!options.forceRefresh && !isTokenExpired(stored)) {
    return stored.accessToken
  }

  if (!stored.refreshToken) {
    clearTokens()
    return null
  }

  if (!options.forceRefresh && inFlightRefresh) {
    return inFlightRefresh
  }

  inFlightRefresh = refreshStoredTokens(stored)
  try {
    return await inFlightRefresh
  } finally {
    inFlightRefresh = null
  }
}

async function refreshStoredTokens(stored: StoredTokens): Promise<string | null> {
  if (!stored.refreshToken) return null
  try {
    const next = await refreshAccessToken(readSsoConfig(), stored.refreshToken)
    saveTokens({
      accessToken: next.accessToken,
      refreshToken: next.refreshToken ?? stored.refreshToken,
      idToken: next.idToken ?? stored.idToken,
      expiresAt:
        typeof next.expiresIn === 'number'
          ? Date.now() + next.expiresIn * 1000
          : undefined,
    })
    return next.accessToken
  } catch {
    clearTokens()
    return null
  }
}
